<app-dashboard *ngIf="authorized ; else unauthorized"></app-dashboard>
<ng-template #unauthorized>
    <app-logout></app-logout>
</ng-template>